/**
 * Persist per-topic actual start/end/duration on the session.
 */

import { livekitAuthService as authService } from "../utils/authService";
import type { TopicTimingRecord } from "./topicProgress/types";

export async function upsertTopicTiming(
  sessionId: string | number,
  record: TopicTimingRecord,
): Promise<TopicTimingRecord[]> {
  const res = await authService.post(
    `/session/sessions/${sessionId}/topic-timing/`,
    record,
  );
  const list = res?.data?.topic_timing;
  return Array.isArray(list) ? (list as TopicTimingRecord[]) : [];
}
